import { isUsGeoCohort } from 'helpers/isUsGeoCohort'

import { useCohortInfo } from './useCohortInfo'

export const useIsUsGeoCohort = (): boolean => {
  const { cohortToUse } = useCohortInfo()

  return isUsGeoCohort(cohortToUse)
}
